import API from '@/views/Fdc/Apis/'
import Dayjs from 'dayjs'

export default {
  name: 'LotsModal',
  watch: {
    selectPeriodValue () {
      let value = this.selectPeriodValue
      if (value === 'lastLot') {
        this.from = null
        this.to = null
        this.periodDisabled = true
        this.lastLotCntDisabled = false
      } else if (value === 'day') {
        this.from = Dayjs().subtract(1, 'days').toDate()
        this.to = new Date()
        this.periodDisabled = true
        this.lastLotCntDisabled = true
      } else if (value === 'week') {
        this.from = Dayjs().subtract(1, 'weeks').toDate()
        this.to = new Date()
        this.periodDisabled = true
        this.lastLotCntDisabled = true
      } else if (value === 'month') {
        this.from = Dayjs().subtract(1, 'months').toDate()
        this.to = new Date()
        this.periodDisabled = true
        this.lastLotCntDisabled = true
      } else if (value === 'custom') {
        this.periodDisabled = false
        this.lastLotCntDisabled = true
      }
    },
    lotsModalVisible () {
      this.modalVisible = this.lotsModalVisible
    }
  },
  updated () {
    // TODO: 적용 필요 시 수정
    // if (this.$refs.lotsGrd) {
    //   this.$watch(
    //     // () => this.$refs.lotsGrd.checkedRows.length,
    //     () => this.$refs.lotsGrd.getCheckedRows().length,
    //     (value) => {
    //       this.selectedRowCnt = value
    //     }
    //   )
    // }
  },
  props: {
    lotsModalVisible: {
      type: Boolean,
      default: false
    },
    // FAB, EQP, MODULE, RECIPE 정보
    modelRowData: {
    },
    modelType: {
      type: String,
      default: ''
    }
  },
  methods: {
    // initLotsModalGrid (grid) {
    //   this.lotsGrd = grid

    //   grid.itemsSourceChanged.addHandler((s, e) => {
    //     for (let i in s.rows) {
    //       if (s.rows[i] && s.rows[i].dataItem) {
    //         s.rows[i].dataItem._status.checked = true
    //       }
    //     }
    //   })
    // },
    async listFn () {
      if (this.selectPeriodValue !== 'lastLot' && (this.from === null || this.to === null)) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Period']))
        return
      }

      let payload

      /**
       * Lot list param 정의
       * @param {String} fab
       * @param {String} eqpId
       * @param {String} module
       * @param {String} recipeId (ALL일 경우에는 필요 x)
       * @param {String} fromDate
       * @param {String} toDate
       * @param {String} lastLotCnt 최근 lot 건수
       * @param {String} fault 갯수
       * @param {String} alarm 갯수
       * @param {String} Interlock 갯수
       */
      payload = {
        fab: this.modelRowData.fab,
        eqpId: this.modelRowData.eqpId,
        moduleId: this.modelRowData.moduleId,
        recipeId: this.modelRowData.recipeId !== 'ALL' ? this.modelRowData.recipeId : null,
        startDt: this.selectPeriodValue !== 'lastLot' ? Dayjs(this.from).format('YYYY-MM-DD HH:mm:ss.SSS').toString() : null,
        endDt: this.selectPeriodValue !== 'lastLot' ? Dayjs(this.to).format('YYYY-MM-DD HH:mm:ss.SSS').toString() : null,
        lastLotCnt: !this.lastLotCntDisabled ? this.lastLotCnt : null
      }

      // Lot 정보 조회 API 호출
      let data = await API.Analysis.getSpcSummaryLots(payload)
      if (data.length === 0) {
        this.$dialog.alert(this.$t('fdc.SPC.MESSAGE.LOT_LIST_NOTFOUND'))
      }
      this.rowData = data
      this.originRowData = data

      setTimeout(() => {
        this.$refs.lotsGrd.setAllRowsSelected()
      })
    },
    searchProcess () {
      this.listFn()
    },
    resetModalData () {
      this.$emit('lots-modal-visible', false)
      this.selectPeriodValue = 'lastLot'
      this.lastLotCnt = '10'
      this.lastLotCntDisabled = false
      this.from = null
      this.to = null
      this.periodDisabled = true
      this.lotsGrd = null
      this.rowData = []
      this.originRowData = []
      this.selectedRowCnt = 0
    },
    applyLots () {
      // let checkedRows = this.$refs.lotsGrd.checkedRows
      let checkedRows = this.$refs.lotsGrd.getCheckedRows()
      if (checkedRows.length > 0) {
        let applyRows = []
        for (let i in checkedRows) {
          applyRows.push(checkedRows[i].lotId)
        }
        this.$emit('apply-lots', applyRows)
        this.resetModalData()
      } else {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['LOT']))
      }
    },
    /**
     * Select Lots Grid에 check된 row count 확인
     * @returns {Boolean} check된 row가 있는지 여부
     */
    hasCheckedRows () {
      if (!this.$refs.lotsGrd) {
        this.selectedRowCnt = 0
        return 0
      }
      this.selectedRowCnt = this.$refs.lotsGrd.checkedRowCount
      return this.$refs.lotsGrd.checkedRowCount > 0
    }
  },
  data () {
    return {
      lotsGrd: null,
      modalVisible: false,
      selectPeriodValue: 'lastLot',
      lastLotCnt: '10',
      lastLotCntDisabled: false,
      from: null,
      to: null,
      periodDisabled: true,
      rowData: [],
      originRowData: [],
      selectedRowCnt: 0,
      columns: [
        { hedarName: this.$t('fdc.COMMON.COLUMN.FAB'), field: 'fabId', width: 70, hide: true },
        { hedarName: this.$t('fdc.COMMON.COLUMN.EQP_ID'), field: 'eqpId', width: 70, hide: true },
        { hedarName: this.$t('fdc.COMMON.COLUMN.MODULE_ID'), field: 'moduleId', width: 70, hide: true },
        { hedarName: this.$t('fdc.COMMON.COLUMN.LOT_ID'), field: 'lotId', width: 100, checkboxSelection: true, headerCheckboxSelection: true },
        { hedarName: this.$t('fdc.COMMON.COLUMN.SUBST_ID'), field: 'substId', width: 150 },
        { hedarName: this.$t('fdc.COMMON.COLUMN.START_DATE'), field: 'startDt', type: 'dateTimeColumn', width: 120 },
        { hedarName: this.$t('fdc.COMMON.COLUMN.END_DATE'), field: 'endDt', type: 'dateTimeColumn', width: 120 },
        { hedarName: this.$t('fdc.COMMON.COLUMN.SLOT'), field: 'slot', type: 'numericColumn', width: 70 },
        { hedarName: this.$t('fdc.COMMON.COLUMN.CARRIER_ID'), field: 'carrId', width: 100 },
        { hedarName: this.$t('fdc.COMMON.COLUMN.RECIPE'), field: 'recipeId', width: 100 },
        { hedarName: this.$t('fdc.COMMON.COLUMN.PROD_ID'), field: 'prodId', width: 100 },
        { hedarName: this.$t('fdc.COMMON.COLUMN.PROCESS'), field: 'procId', width: 100 },
        { hedarName: this.$t('fdc.COMMON.COLUMN.RETICLE_ID'), field: 'reticleId', width: 100 },
        { hedarName: this.$t('fdc.COMMON.COLUMN.PPID'), field: 'ppId', width: 100 },
        { hedarName: this.$t('fdc.COMMON.COLUMN.DEVICE'), field: 'device', width: 100 },
        { hedarName: this.$t('fdc.COMMON.COLUMN.FAULT'), field: 'fault', width: 70 },
        { hedarName: this.$t('fdc.COMMON.COLUMN.ALARM'), field: 'alarm', width: 70 },
        { hedarName: this.$t('fdc.COMMON.COLUMN.INTER_LOCK'), field: 'interlock', width: 70 }
      ],
      defaultColDef: {
        filter: true,
        sortable: true,
        resizable: true,
        editable: false
      } // BRIQUE Grid column default setting
    }
  }
}
